import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { PwaUpdateService } from '@df/module-pwa/update/pwa-update.service';
import { PwaUpdateComponent } from './pwa-update.component';

@Injectable({
    providedIn: 'root'
})
export class PwaUpdateServiceDecorator extends PwaUpdateService {
    override modalOpen(): void {
        //turn off modal for now, lack of design
    }
    override modalComponent(): ComponentType<PwaUpdateComponent> {
        return PwaUpdateComponent;
    }
}
